import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const PdfSimpliFooter = ({ privacyPolicy, termsOfUse, contactUs }) => {
  const { t } = useTranslation();
  const { locale } = useParams();

  return (
    <div className="pdfsimpli-footer bottom-0 w-full  z-40 md:z-0 md:border-t md:border-[#DBDEE1] py-[10px] gap:[20px] h-[48px] text-[#16283D] font-rethink">
      {" "}
      <div className="documents-footer text-center text-[#696c73] text-base flex flex-col md:flex-row items-center justify-center w-full gap-[10px] md:gap-4 mb-[40px] md:!mb-0">
        <a href={privacyPolicy} target="_blank" className="">
          <span>{t("footer.ps.privacy_policy")}</span>
          <span className="block md:inline mx-0 md:mx-2 rotate-[-90deg] md:rotate-0 origin-center text-[#0E76FF] text-base">
            |
          </span>
        </a>
        <a className="" href={termsOfUse} target="_blank">
          <span>{t("footer.ps.terms_condition")}</span>
          <span className="block md:inline mx-0 md:mx-2 rotate-[-90deg] md:rotate-0 origin-center text-[#0E76FF] text-base">
            |
          </span>
        </a>
        <a className="" href={contactUs} target="_blank">
          {t("footer.ps.contact_us")}
        </a>
      </div>
      <div className="text-center text-[#FDFDFD] text-[11px] p-2 md:p-[15px] md:text-[13px] font-normal bg-[#0E76FF] mt-1">
        © {new Date().getFullYear()}
        {" , "}
        {t("footer.ps.subsidiary")}
        <a rel="nofollow noopener noreferrer" href="https://www.solidframework.net/" target="_blank">
          <span className="text-[#FDFDFD] font-bold"> {t("footer.ps.solid_doc")}</span>
        </a>
        {t("footer.ps.and")}
        <a rel="nofollow noopener noreferrer" href="https://www.aspose.com" target="_blank">
          <span className="text-[#FDFDFD] font-bold" dangerouslySetInnerHTML={{ __html: t("footer.ps.aspose") }} />
        </a>
        {locale && locale === "hi" ? (
          <span style={{ color: "#fff", pointerEvents: "none" }}>{t("footer.ps.proudly_partnering_with")}</span>
        ) : null}
        .
      </div>
    </div>
  );
};

export default PdfSimpliFooter;
